import { getApiUrl } from "./tcApiUrl";
export function getTransactionsURL() {
  const classifyurl = `${getApiUrl("userTransactions")}`;
  return classifyurl;
}

export const getTransactionsURLValue = () => {
  return getTransactionsURL();
};
